import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './CookieBanner.css';

const COOKIE_NAME = 'appConsent';
const COOKIE_OPTIONS = { expires: 365, sameSite: 'Lax' };

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    let consent = {};
    const raw = Cookies.get(COOKIE_NAME);
    if (raw) {
      try {
        consent = JSON.parse(raw);
      } catch {
        consent = {};
      }
    }

    if (!raw) {
      consent = { marketingConsent: true, asked: false };
      Cookies.set(COOKIE_NAME, JSON.stringify(consent), COOKIE_OPTIONS);
    }

    window.dataLayer.push({
      event: 'cookie_consent_init',
      marketingConsent: consent.marketingConsent,
    });

    if (consent.asked === false) {
      window.dataLayer.push({
        event: 'cookie_consent_update',
        marketingConsent: consent.marketingConsent,
      });
      setVisible(true);
    }
  }, []);

  const updateConsent = marketingBool => {
    const newConsent = { marketingConsent: marketingBool, asked: true };
    Cookies.set(COOKIE_NAME, JSON.stringify(newConsent), COOKIE_OPTIONS);
    window.dataLayer.push({
      event: 'cookie_consent_update',
      marketingConsent: marketingBool,
    });
  };

  const handleAccept = () => {
    updateConsent(true);
    setVisible(false);
  };

  const handleDecline = () => {
    updateConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className='cookie-banner'>
      <div className='cookie-banner__inner'>
        <p className='cookie-banner__message'>
        🍪 We use cookies to understand site traffic, make our app better, and improve our marketing efforts. 
          Click “Decline” to opt-out of marketing cookies. 🍪
        </p>
        <div className='cookie-banner__buttons'>
          <button
            className='cookie-banner__button cookie-banner__button--decline'
            onClick={handleDecline}
          >
            Decline
          </button>
          <button
            className='cookie-banner__button'
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}


